export default "__VITE_ASSET__D9u_qyiQ__"